// Şube başına GA4. gtag.js bir kez yüklenir, görüntüleme her şube gezinmesinde elle atılır.
//
// İki tuzak bu yapıyı zorunlu kılıyor:
//   - gtag'de config geri alınamaz. Şube değişiminde ikinci bir config bırakılırsa sonraki her
//     hit İKİ property'ye birden gider — A şubesinin sahibi B'nin trafiğini görür. Resmî kapatma
//     yolu window['ga-disable-<id>'] bayrağı, o yüzden eski id gidince bayrak kalkıyor.
//   - İki şube aynı ölçüm kimliğini paylaşabilir (marka geneli tek property). O durumda config
//     değişmez ama ikinci şubenin görüntülenmesi yine sayılmalı; bu yüzden page_view config'e
//     bırakılmayıp send_page_view kapalı bırakılıyor ve olay elle gönderiliyor.
let scriptRequested = false;
let activeId = null;

const loadScript = (measurementId) => {
  scriptRequested = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  // Yüklenemezse (offline, ad-blocker) kilidi aç ki sonraki gezinme tekrar denesin.
  script.onerror = () => {
    console.warn("[menu] gtag yüklenemedi", measurementId);
    scriptRequested = false;
    activeId = null;
  };
  document.head.appendChild(script);
};

export const setAnalytics = (measurementId) => {
  const id = measurementId?.trim();

  if (!id) {
    return;
  }

  if (!scriptRequested) {
    loadScript(id);
  }

  if (activeId !== id) {
    if (activeId) {
      window[`ga-disable-${activeId}`] = true;
    }
    window[`ga-disable-${id}`] = false;
    activeId = id;
    window.gtag("config", id, { send_page_view: false });
  }

  window.gtag("event", "page_view");
};

// Değerlendirme kartına tıklama. Kart işe yarıyor mu sorusunun tek ölçüsü bu — Google yorum
// sayısını bize söylemiyor, hangi şubeden kaç kişinin yola çıktığını yalnızca burada görüyoruz.
//
// gtag hiç yüklenmemişse (şubede GA kapalı, betik engellendi) sessizce geçiyor: ölçüm yokluğu
// müşterinin Google'a gitmesini engellememeli.
export const trackReviewClick = (branchSlug) => {
  if (typeof window.gtag !== "function") {
    return;
  }

  window.gtag("event", "review_click", { branch: branchSlug });
};
